import { render, staticRenderFns } from "./NextPreviousButton.vue?vue&type=template&id=6325557e&"
import script from "./NextPreviousButton.vue?vue&type=script&lang=ts&"
export * from "./NextPreviousButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports